import { render } from "./DialLegenda.vue?vue&type=template&id=b7d7794e&scoped=true"
import script from "./DialLegenda.vue?vue&type=script&lang=js"
export * from "./DialLegenda.vue?vue&type=script&lang=js"

import "./DialLegenda.vue?vue&type=style&index=0&id=b7d7794e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7d7794e"]])

export default __exports__